var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            "label-width": "262px",
            model: _vm.form,
            rules: _vm.rules,
            "label-position": "left",
          },
        },
        [
          _c(
            "el-collapse",
            {
              staticClass: "payment-link-collapse",
              model: {
                value: _vm.activeNames,
                callback: function ($$v) {
                  _vm.activeNames = $$v
                },
                expression: "activeNames",
              },
            },
            [
              _c(
                "el-collapse-item",
                {
                  class: {
                    "link-info-collapse":
                      _vm.form.link_mode === _vm.LINK_MODE.basedOnProduct,
                  },
                  attrs: {
                    title: _vm.$t("payment_links.link_info"),
                    name: "1",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("payment_links.link_icon"),
                        prop: "link_icon",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "avatar-wrapper" },
                        [
                          _vm.form.link_logo_oss_url
                            ? _c("img", {
                                staticClass: "img-avatar",
                                attrs: { src: _vm.form.link_logo_oss_url },
                                on: { click: _vm.onClickEditLogo },
                              })
                            : _vm._e(),
                          !_vm.isDetails
                            ? _c(
                                "el-button",
                                { on: { click: _vm.onClickEditLogo } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("payment_links.upload_photo"))
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("AvatorUpload", {
                        attrs: {
                          "model-value": _vm.showAvatorUpload,
                          field: "img",
                          "lang-ext": _vm.langExt,
                          "lang-type": _vm.$store.getters.language,
                          "no-square": "",
                        },
                        on: {
                          "update:modelValue": _vm.onChangeAvatorUpload,
                          "crop-success": _vm.cropSuccess,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("payment_links.link_no"),
                        prop: "mch_ref_no",
                      },
                    },
                    [
                      _vm.$route.query.type
                        ? _c("span", { staticClass: "content-text" }, [
                            _vm._v(_vm._s(_vm.form.mch_ref_no)),
                          ])
                        : _c("el-input", {
                            staticClass: "from-input",
                            attrs: {
                              disabled: _vm.isDetails,
                              placeholder: _vm.$t("payment_links.link_no"),
                              size: "small",
                              type: "text",
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.mch_ref_no,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "mch_ref_no",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.mch_ref_no",
                            },
                          }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("payment_links.link_title"),
                        prop: "title",
                      },
                    },
                    [
                      _vm.isDetails
                        ? _c("span", { staticClass: "content-text" }, [
                            _vm._v(_vm._s(_vm.form.title)),
                          ])
                        : _c("el-input", {
                            staticClass: "from-input",
                            attrs: {
                              disabled: _vm.isDetails,
                              maxlength: "50",
                              placeholder: _vm.$t("payment_links.link_title"),
                              size: "small",
                              type: "text",
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "title", $$v)
                              },
                              expression: "form.title",
                            },
                          }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("payment_links.order_mode"),
                        prop: "link_mode",
                        required: "",
                      },
                    },
                    [
                      _vm.isDetails
                        ? _c("span", { staticClass: "content-text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.getLinkModeMapLabel(_vm.form.link_mode)
                              )
                            ),
                          ])
                        : _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: _vm.isDetails },
                              on: { input: _vm.onChangeOrderMode },
                              model: {
                                value: _vm.form.link_mode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "link_mode", $$v)
                                },
                                expression: "form.link_mode",
                              },
                            },
                            [
                              _c(
                                "el-radio",
                                { attrs: { label: _vm.LINK_MODE.fixedAmount } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("payment_links.fixed_amount"))
                                  ),
                                ]
                              ),
                              _c(
                                "el-radio",
                                {
                                  attrs: {
                                    label: _vm.LINK_MODE.basedOnProduct,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("payment_links.based_on_product")
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "el-radio",
                                {
                                  attrs: {
                                    label: _vm.LINK_MODE.customerToEnter,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("payment_links.customer_to_enter")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                  _vm.form.link_mode === _vm.LINK_MODE.fixedAmount
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("payment_links.amount"),
                            prop: "amount",
                          },
                        },
                        [
                          _vm.isDetails
                            ? _c("span", { staticClass: "content-text" }, [
                                _vm._v(
                                  _vm._s(_vm._f("numWithDot")(_vm.form.amount))
                                ),
                              ])
                            : _c("el-input", {
                                staticClass: "from-input",
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$t("payment_links.amount"),
                                  autocomplete: "off",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.amount,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "amount", $$v)
                                  },
                                  expression: "form.amount",
                                },
                              }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("payment_links.payment_description"),
                        prop: "description",
                      },
                    },
                    [
                      _vm.isDetails
                        ? _c("span", { staticClass: "content-text" }, [
                            _vm._v(_vm._s(_vm.form.description)),
                          ])
                        : _c("el-input", {
                            staticClass: "from-input",
                            attrs: {
                              disabled: _vm.isDetails,
                              maxlength: "256",
                              placeholder: _vm.$t(
                                "payment_links.payment_description"
                              ),
                              autosize: "",
                              type: "textarea",
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "description", $$v)
                              },
                              expression: "form.description",
                            },
                          }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("payment_links.remark"),
                        prop: "remark",
                      },
                    },
                    [
                      _vm.isDetails
                        ? _c("span", { staticClass: "content-text" }, [
                            _vm._v(_vm._s(_vm.form.remark || "-")),
                          ])
                        : _c("el-input", {
                            staticClass: "from-input",
                            attrs: {
                              disabled: _vm.isDetails,
                              maxlength: "256",
                              placeholder: _vm.$t("payment_links.remark"),
                              autosize: "",
                              type: "textarea",
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "remark", $$v)
                              },
                              expression: "form.remark",
                            },
                          }),
                    ],
                    1
                  ),
                  _vm.form.link_mode === _vm.LINK_MODE.basedOnProduct
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("payment_links.product"),
                            prop: "product",
                          },
                        },
                        [
                          !_vm.isDetails
                            ? _c(
                                "el-select",
                                {
                                  staticClass: "product-select",
                                  attrs: {
                                    disabled: _vm.isDetails,
                                    filterable: "",
                                    "filter-method": _vm.filterMethod,
                                    placeholder: _vm.$t(
                                      "payment_links.add_product_or_search_on_list"
                                    ),
                                    "popper-append-to-body": false,
                                    size: "small",
                                    clearable: "",
                                  },
                                  on: { clear: _vm.clearProduct },
                                  model: {
                                    value: _vm.form.product,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "product", $$v)
                                    },
                                    expression: "form.product",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "infinite-scroll",
                                          rawName: "v-infinite-scroll",
                                          value: _vm.scrollProduct,
                                          expression: "scrollProduct",
                                        },
                                      ],
                                    },
                                    [
                                      _c(
                                        "el-option",
                                        { attrs: { value: "", disabled: "" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "add-new-product",
                                              on: { click: _vm.addProduct },
                                            },
                                            [
                                              _vm._v(
                                                " + " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "payment_links.add_new_product"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._l(
                                        _vm.productList,
                                        function (item, index) {
                                          return _c(
                                            "el-option",
                                            {
                                              key: index,
                                              attrs: {
                                                label: item.name,
                                                value: item.name,
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "product-item",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.selectProduct(
                                                        item,
                                                        index
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "product-info",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "product-name",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.name
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "price",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$store
                                                                  .getters
                                                                  .currency
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "toDivideWithDot"
                                                                )(item.price)
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    [
                                                      _c("svg-icon", {
                                                        attrs: {
                                                          "class-name":
                                                            "add-icon",
                                                          "icon-class":
                                                            "icon-edit",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.editProduct(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _c("svg-icon", {
                                                        attrs: {
                                                          "class-name":
                                                            "add-icon",
                                                          "icon-class":
                                                            "icon-delete",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.clickDeleteBtn(
                                                              item.product_no
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      _vm.productListAllSet.size ===
                                        _vm.total ||
                                      _vm.productList.length === 0
                                        ? _c(
                                            "el-option",
                                            {
                                              attrs: {
                                                value: "",
                                                disabled: "",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "no-data-item" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "payment_links.no_more_data"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "tableContainer" },
                    [
                      _vm.form.link_mode === _vm.LINK_MODE.basedOnProduct
                        ? _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.selectedProductList,
                                stripe: "",
                                fit: "",
                                "max-height": "500",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("payment_links.product_name"),
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(scope.row.name)),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2020036417
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("payment_links.price"),
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("toDivideWithDot")(
                                                  scope.row.price
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1812945607
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("payment_links.quantity"),
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm.isDetails
                                            ? _c(
                                                "span",
                                                { staticClass: "content-text" },
                                                [
                                                  _vm._v(
                                                    _vm._s(scope.row.quantity)
                                                  ),
                                                ]
                                              )
                                            : _c("el-input-number", {
                                                attrs: {
                                                  size: "mini",
                                                  placeholder: _vm.$t(
                                                    "payment_links.quantity"
                                                  ),
                                                  autocomplete: "on",
                                                  max: 99,
                                                  min:
                                                    scope.row.allow_adjust === 1
                                                      ? 0
                                                      : 1,
                                                  clearable: "",
                                                  controls: false,
                                                  type: "text",
                                                  precision: 0,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.changeQuantity(
                                                      scope.row,
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: scope.row.quantity,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "quantity",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.quantity",
                                                },
                                              }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1535054846
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("payment_links.allow_adjust"),
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm.isDetails
                                            ? _c(
                                                "span",
                                                { staticClass: "content-text" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.allow_adjust ===
                                                        1
                                                        ? _vm.$t(
                                                            "components.yes"
                                                          )
                                                        : _vm.$t(
                                                            "components.no"
                                                          )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _c("el-checkbox", {
                                                staticClass: "checkbox",
                                                attrs: {
                                                  "true-label": 1,
                                                  "false-label": 2,
                                                  disabled: _vm.isDetails,
                                                  size: "medium",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.changeAllowAdjust(
                                                      scope.row,
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: scope.row.allow_adjust,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "allow_adjust",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.allow_adjust",
                                                },
                                              }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3261130036
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("payment_links.image"),
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("img", {
                                            directives: [
                                              {
                                                name: "viewer",
                                                rawName: "v-viewer",
                                              },
                                            ],
                                            staticStyle: { cursor: "pointer" },
                                            attrs: {
                                              src: scope.row.pic,
                                              height: "40px",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3016818274
                                ),
                              }),
                              !_vm.isDetails
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("components.operation"),
                                      align: "center",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-tooltip",
                                                { attrs: { placement: "top" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      attrs: {
                                                        slot: "content",
                                                      },
                                                      slot: "content",
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "components.delete"
                                                              )
                                                            )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c("svg-icon", {
                                                    attrs: {
                                                      "class-name":
                                                        "icon-function",
                                                      "icon-class":
                                                        "icon-delete",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.onClickDeleteBtn(
                                                          scope.row,
                                                          scope.$index
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      637666301
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-collapse-item",
                {
                  attrs: {
                    title: _vm.$t("payment_links.customer_info"),
                    name: "2",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("payment_links.collect_customer_info"),
                        prop: "collect_mode",
                        required: "",
                      },
                    },
                    [
                      _vm.isDetails
                        ? _c("span", { staticClass: "content-text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.getCollectModeMapLabel(
                                  _vm.form.collect_mode
                                )
                              )
                            ),
                          ])
                        : _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: _vm.isDetails },
                              model: {
                                value: _vm.form.collect_mode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "collect_mode", $$v)
                                },
                                expression: "form.collect_mode",
                              },
                            },
                            _vm._l(_vm.collectModeMap, function (item, index) {
                              return _c(
                                "el-radio",
                                { key: index, attrs: { label: item.value } },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                    ],
                    1
                  ),
                  _vm.form.collect_mode === _vm.COLLECT_MODE.no
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("payment_links.customer_name"),
                            prop: "customer_name",
                          },
                        },
                        [
                          _vm.isDetails
                            ? _c("span", { staticClass: "content-text" }, [
                                _vm._v(_vm._s(_vm.form.customer_name)),
                              ])
                            : _c("el-input", {
                                staticClass: "from-input",
                                attrs: {
                                  disabled: _vm.isDetails,
                                  maxlength: "128",
                                  placeholder: _vm.$t(
                                    "payment_links.customer_name"
                                  ),
                                  size: "small",
                                  type: "text",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.customer_name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "customer_name", $$v)
                                  },
                                  expression: "form.customer_name",
                                },
                              }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.collect_mode === _vm.COLLECT_MODE.no
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("payment_links.customer_email"),
                            prop: "email",
                          },
                        },
                        [
                          _vm.isDetails
                            ? _c("span", { staticClass: "content-text" }, [
                                _vm._v(_vm._s(_vm.form.email)),
                              ])
                            : _c("el-input", {
                                staticClass: "from-input",
                                attrs: {
                                  disabled: _vm.isDetails,
                                  placeholder: _vm.$t(
                                    "payment_links.customer_email"
                                  ),
                                  size: "small",
                                  type: "text",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.email,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "email",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.email",
                                },
                              }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.collect_mode === _vm.COLLECT_MODE.no
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("payment_links.customer_mobile"),
                            prop: "mobile",
                          },
                        },
                        [
                          _vm.isDetails
                            ? _c("span", { staticClass: "content-text" }, [
                                _vm._v(_vm._s(_vm.form.mobile)),
                              ])
                            : _c("el-input", {
                                staticClass: "from-input",
                                attrs: {
                                  disabled: _vm.isDetails,
                                  placeholder: _vm.$t(
                                    "payment_links.customer_mobile"
                                  ),
                                  size: "small",
                                  type: "text",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.mobile,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "mobile",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.mobile",
                                },
                              }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-collapse-item",
                {
                  attrs: {
                    title: _vm.$t("payment_links.other_info"),
                    name: "3",
                  },
                },
                [
                  _vm.isEdit
                    ? _c("div", { staticClass: "customer-info-tips" }, [
                        _vm._v(
                          _vm._s(_vm.$t("payment_links.available_edits_left")) +
                            ":" +
                            _vm._s(_vm.modificationCount)
                        ),
                      ])
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("payment_links.add_customer_field"),
                        prop: "field_type",
                        required: "",
                      },
                    },
                    [
                      (_vm.isEdit && !_vm.modificationCount) || _vm.isDetails
                        ? _c("span", { staticClass: "content-text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.getAddCustomerFieldModeMapLabel(
                                  _vm.form.field_type
                                )
                              )
                            ),
                          ])
                        : _c(
                            "el-radio-group",
                            {
                              on: {
                                change: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                              model: {
                                value: _vm.form.field_type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "field_type", $$v)
                                },
                                expression: "form.field_type",
                              },
                            },
                            _vm._l(
                              _vm.addCustomerFieldModeMap,
                              function (item, index) {
                                return _c(
                                  "el-radio",
                                  { key: index, attrs: { label: item.value } },
                                  [_vm._v(_vm._s(item.label))]
                                )
                              }
                            ),
                            1
                          ),
                    ],
                    1
                  ),
                  _vm.form.field_type === _vm.ADD_CUSTOMER_FIELD.yes
                    ? _c(
                        "div",
                        { staticClass: "customer-info" },
                        _vm._l(_vm.form.field_list, function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "customer-info-item" },
                            [
                              _c(
                                "div",
                                { staticClass: "left" },
                                [
                                  (_vm.isEdit && !_vm.modificationCount) ||
                                  _vm.isDetails
                                    ? _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass:
                                            "content-text field-select-item",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getCustomerTypeMapLabel(
                                                item.type
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "el-select",
                                        {
                                          key: index,
                                          staticClass: "field-select-item",
                                          attrs: {
                                            size: "small",
                                            clearable: "",
                                          },
                                          model: {
                                            value: item.type,
                                            callback: function ($$v) {
                                              _vm.$set(item, "type", $$v)
                                            },
                                            expression: "item.type",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label:
                                                _vm.$t("payment_links.text"),
                                              value: _vm.CUSTOMER_FIELD.text,
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "payment_links.number_only"
                                              ),
                                              value:
                                                _vm.CUSTOMER_FIELD.numberOnly,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "right" },
                                [
                                  (_vm.isEdit && !_vm.modificationCount) ||
                                  _vm.isDetails
                                    ? _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "content-text",
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    : _c("el-input", {
                                        staticClass:
                                          "field-label-item from-input",
                                        attrs: {
                                          maxlength: "64",
                                          placeholder: _vm.$t(
                                            "payment_links.label_name"
                                          ),
                                          size: "small",
                                          type: "text",
                                          clearable: "",
                                        },
                                        model: {
                                          value: item.name,
                                          callback: function ($$v) {
                                            _vm.$set(item, "name", $$v)
                                          },
                                          expression: "item.name",
                                        },
                                      }),
                                  _vm.modificationCount && !_vm.isDetails
                                    ? _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.form.field_list.length > 1,
                                              expression:
                                                "form.field_list.length>1",
                                            },
                                          ],
                                          staticClass: "delete-btn",
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteCustomerField(
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("components.delete"))
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.modificationCount && !_vm.isDetails
                                    ? _c("br")
                                    : _vm._e(),
                                  (_vm.isEdit && !_vm.modificationCount) ||
                                  _vm.isDetails
                                    ? _c(
                                        "span",
                                        { staticClass: "content-text" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.option_type ===
                                                _vm.OPTION_TYPE.required
                                                ? _vm.$t(
                                                    "payment_links.marked_as_required"
                                                  )
                                                : _vm.$t(
                                                    "payment_links.mark_as_optional"
                                                  )
                                            )
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "el-checkbox",
                                        {
                                          staticClass: "checkbox",
                                          attrs: {
                                            "true-label":
                                              _vm.OPTION_TYPE.optional,
                                            "false-label":
                                              _vm.OPTION_TYPE.required,
                                            size: "medium",
                                          },
                                          model: {
                                            value: item.option_type,
                                            callback: function ($$v) {
                                              _vm.$set(item, "option_type", $$v)
                                            },
                                            expression: "item.option_type",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "payment_links.mark_as_optional"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                  _c(
                                    "div",
                                    [
                                      _vm.modificationCount && !_vm.isDetails
                                        ? _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    index ===
                                                    _vm.form.field_list.length -
                                                      1,
                                                  expression:
                                                    "index === form.field_list.length - 1",
                                                },
                                              ],
                                              staticClass: "add-btn",
                                              attrs: { type: "info" },
                                              on: {
                                                click: _vm.addCustomerField,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "payment_links.add_another_field"
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-collapse-item",
                {
                  attrs: {
                    title: _vm.$t("payment_links.payment_success_page"),
                    name: "2",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("payment_links.custom_message"),
                        prop: "custom_message",
                      },
                    },
                    [
                      _vm.isDetails
                        ? _c(
                            "span",
                            {
                              staticClass: "content-text",
                              staticStyle: {
                                "word-break": "break-word",
                                "white-space": "pre-line",
                                "line-height": "1.5",
                              },
                            },
                            [_vm._v(_vm._s(_vm.form.custom_message || "-"))]
                          )
                        : _c("el-input", {
                            staticClass: "from-input",
                            attrs: {
                              disabled: _vm.isDetails,
                              maxlength: 255,
                              "show-word-limit": "",
                              rows: 4,
                              type: "textarea",
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.custom_message,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "custom_message", $$v)
                              },
                              expression: "form.custom_message",
                            },
                          }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-collapse-item",
                {
                  attrs: {
                    title: _vm.$t("payment_links.link_configuration"),
                    name: "4",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("payment_links.link_type"),
                        prop: "link_type",
                        required: "",
                      },
                    },
                    [
                      _vm.isDetails
                        ? _c("span", { staticClass: "content-text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.getLinkTypeMapLabel(_vm.form.link_type)
                              )
                            ),
                          ])
                        : _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: _vm.isDetails },
                              on: { input: _vm.onChangeOrderTimes },
                              model: {
                                value: _vm.form.link_type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "link_type", $$v)
                                },
                                expression: "form.link_type",
                              },
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: {
                                    label: _vm.LINK_TYPE.one,
                                    disabled:
                                      _vm.form.link_mode ===
                                      _vm.LINK_MODE.customerToEnter,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("payment_links.one_time"))
                                  ),
                                ]
                              ),
                              _c(
                                "el-radio",
                                { attrs: { label: _vm.LINK_TYPE.more } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("payment_links.reusable"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                  _vm.form.link_type === _vm.LINK_TYPE["more"]
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "payment_links.max_of_payments_accepted"
                            ),
                            prop: "max_limit",
                          },
                        },
                        [
                          _vm.isDetails
                            ? _c("span", { staticClass: "content-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.form.max_limit ||
                                      _vm.$t("payment_links.unlimited")
                                  )
                                ),
                              ])
                            : _c("el-input", {
                                staticClass: "from-input",
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$t(
                                    "payment_links.max_of_payments_accepted"
                                  ),
                                  autocomplete: "off",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.max_limit,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "max_limit", $$v)
                                  },
                                  expression: "form.max_limit",
                                },
                              }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "expire_time" } },
                    [
                      _c("template", { slot: "label" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("payment_links.expiry_time")) +
                            " "
                        ),
                      ]),
                      _vm.isDetails
                        ? _c("span", { staticClass: "content-text" }, [
                            _vm._v(_vm._s(_vm.form.expire_time || "-")),
                          ])
                        : _c("el-date-picker", {
                            staticClass: "from-input",
                            attrs: {
                              type: "datetime",
                              placeholder: _vm.$t("payment_links.expiry_time"),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              "picker-options": _vm.pickerOptions,
                              align: "right",
                              clearable: "",
                              size: "small",
                            },
                            on: { focus: _vm.focus },
                            model: {
                              value: _vm.form.expire_time,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "expire_time", $$v)
                              },
                              expression: "form.expire_time",
                            },
                          }),
                    ],
                    2
                  ),
                  _c("div", { staticClass: "time-zone-tips" }, [
                    _vm._v(
                      _vm._s(_vm.$t("payment_links.time_zone_tips")) + ":UTC+8"
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "dialog-footer" },
            [
              !_vm.isDetails
                ? _c("el-button", { on: { click: _vm.goBack } }, [
                    _vm._v(_vm._s(_vm.$t("components.cancel"))),
                  ])
                : _vm._e(),
              !_vm.isDetails
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn-submit",
                      attrs: { type: "primary", disabled: _vm.submitLoading },
                      on: {
                        click: function ($event) {
                          return _vm.onClickSubmitBtn("form")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("components.confirm")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("AddNewProudct", {
        ref: "addNewProudct",
        on: {
          getProductList: _vm.getProductList,
          clearProduct: _vm.clearProduct,
        },
      }),
      _c("CreateSuccessful", { ref: "createSuccessful" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }